import React from 'react'
import _ from 'lodash'
import { Header, Table, Label } from 'semantic-ui-react'

export default class LifeSpanList extends React.PureComponent {
  renderLatencyColumn = latency => {
    const { successOrderCount, lateOrderCount, slowestLateOrder, fatestLateOrder, avgLateOrder } = latency

    if (lateOrderCount === 0) return <div/>

    return (
      <div style={{ width: 205 }}>
        <div style={{ marginBottom: 5 }}>
          <Label style={{ width: 100 }}>Late: {lateOrderCount}/{successOrderCount}</Label>
          <Label style={{ width: 100 }}>Avg: {avgLateOrder}mn</Label>
        </div>
        <div>
          <Label style={{ width: 100 }}>Min: {fatestLateOrder}mn</Label>
          <Label style={{ width: 100 }}>Max: {slowestLateOrder}mn</Label>
        </div>
      </div>
    )
  }

  renderRows = () => {
    const { mergeRowTime, muuverLifeSpan, orderLifeSpan, latency } = this.props

    if (_.size(mergeRowTime) > 0) {
      return _.map(mergeRowTime, ({ onlineCount, offlineCount, formattedHour }, index) => {
        return (
          <Table.Row key={index}>
            <Table.Cell textAlign="center">{formattedHour}</Table.Cell>
            <Table.Cell textAlign="center">{onlineCount}</Table.Cell>
            <Table.Cell textAlign="center">{offlineCount}</Table.Cell>
            <Table.Cell textAlign="center">{muuverLifeSpan[index] || 0}</Table.Cell>
            <Table.Cell textAlign="center">{orderLifeSpan[index] || 0}</Table.Cell>
            <Table.Cell textAlign="center">{this.renderLatencyColumn(latency[index])}</Table.Cell>
          </Table.Row>
        )
      })
    }

    return (
      <Table.Row>
        <Table.Cell colSpan={6} textAlign="center" style={{ padding: 40 }}>
          <Header size="small">No data available</Header>
        </Table.Cell>
      </Table.Row>
    )
  }

  render() {
    return (
      <Table columns={5} selectable>
        <Table.Header>
          <Table.Row style={{ fontWeight: 'bold' }}>
            <Table.Cell textAlign="center">Time</Table.Cell>
            <Table.Cell textAlign="center">Online</Table.Cell>
            <Table.Cell textAlign="center">Offline</Table.Cell>
            <Table.Cell textAlign="center">Muuver Lifespan</Table.Cell>
            <Table.Cell textAlign="center">Orders Lifespan</Table.Cell>
            <Table.Cell textAlign="center">Latency</Table.Cell>
          </Table.Row>
        </Table.Header>
        <Table.Body>{this.renderRows()}</Table.Body>
      </Table>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/drivers/views/lifeSpanList.js